// extracted by mini-css-extract-plugin
export default {"imageWrapper":"OX-z","hovered":"PX-z","hoverImage":"QX-z","mainImage":"RX-z","imageNoBackground":"SX-z","fullSizeImage":"TX-z"};